import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import {
    addCommas,
    convertStartEndDatesForFile
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import ProductUnitTableIcon from 'material-ui/svg-icons/action/receipt';

const styles = {
    reportHeader: {
        margin: '1em 0 5px 0',
    },
};

/**
 * Class for displaying Detailed Sales Product Unit Sales Summary in a table
 *
 */
class DetailedSalesReportSalesSummaryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listTableData: [],
            tableHeaders: [
                {label: 'Barcode', key: 'barcode'},
                {label: 'Product Unit Name', key: 'product'},
                {label: 'Product Category', key: 'category'},
                {label: 'Units', key: 'units'},
            ],
            paymentTotals: {
                products: 0,
                transactions: 0,
                units: 0
            },
            summaryComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleProductSortChange = this.handleProductSortChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData, this.props.paymentTotals);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.listData !== this.props.listData ||
            nextProps.paymentTotals !== this.props.paymentTotals
        ) {
            this.setState({
                summaryList: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.listData !== this.props.listData ||
            prevProps.paymentTotals !== this.props.paymentTotals
        ) {
            this.processData(this.props.listData, this.props.paymentTotals);
        }
    }

    processData(data, totals) {
        let listData = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                let s = data[i];
                let product = s.product_info.hits.hits[0]._source;
                let row = {
                    barcode: (product.product_unit_id) ? product.product_unit_id : 0,
                    product: (product.product_name) ? product.product_name : '(None)',
                    category: (product.product_category_name) ? product.product_category_name : '(None)',
                    units: (s.qty && s.qty.value) ? s.qty.value : 0,
                };
                listData.push(row);
            }
        }

        // Finalize table data
        this.setState({
            listTableData: listData,
            paymentTotals: {
                products: addCommas(totals.products),
                transactions: addCommas(totals.transactions),
                units: addCommas(totals.units)
            },
            summaryComplete: true
        }, () => {
            if (typeof this.props.onSummaryComplete === 'function') {
                this.props.onSummaryComplete('sales', true);
            }
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update current Product Unit table data based on sort
     *
     * @param event
     */
    handleProductSortChange(event) {
        const tableData = getTableState(this.productUnitReactTable);
        if (tableData && tableData.length > 0) {
            this.setState({
                listTableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            endDate,
            locationId,
            startDate,
            system
        } = this.props;

        const {
            listTableData,
            tableHeaders,
            paymentTotals,
            summaryComplete
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('barcode');

        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Barcode',
                        accessor: 'barcode',
                        style: tableStyles.tdMin
                    },
                    {
                        Header: 'Product Unit Name',
                        accessor: 'product',
                        style: tableStyles.tdMin
                    },
                    {
                        Header: 'Product Category',
                        accessor: 'category',
                        style: tableStyles.tdMin,
                    },
                    {
                        Header: 'Units Sold',
                        accessor: 'units',
                        filterable: false,
                        style: tableStyles.right,
                        headerStyle: tableStyles.thLast
                    }
                ]
            }
        ];

        return (
            <div>
                {!summaryComplete &&
                    <div className="loader-container">
                        <h4>Generating Report...</h4>
                        <CircularProgress
                            size={24}
                            thickness={2}
                            className="loader"
                        />
                    </div>
                }
                {summaryComplete &&
                    <div className="reports-table-container">

                        {/* Detailed Sales by Product Unit Header */}
                        <div className="report-header" style={styles.reportHeader}>
                            <h2 className="report-header-title">Summary</h2>
                            <p>{paymentTotals.transactions} Transactions, {paymentTotals.products} Products, {paymentTotals.units} Units
                                Sold</p>
                        </div>

                        {/* Table Header: Detailed Sales by Product Unit */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container report-header-button-container">
                                {/* Export Sales by Product Unit */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={commonStyles.headerButton}
                                >
                                    <ExportIcon style={commonStyles.headerButtonIcon}/>
                                    <CSVLink
                                        data={listTableData}
                                        headers={tableHeaders}
                                        filename={'Detailed-Sales-By-Product-Unit-' + system + '-' + locationId + '-' + dateString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={commonStyles.headerButtonLink}
                                    >
                                        Export Sales by Product Unit
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <ProductUnitTableIcon style={commonStyles.summaryIcon}/>
                                <span>Sales by Product Unit</span>
                            </h3>
                        </div>

                        {/* Table: Sales by Product Unit */}
                        <ReactTable
                            key="table-detailed-sales-product-unit"
                            data={listTableData}
                            columns={tableColumns}
                            defaultPageSize={10000}
                            showPagination={false}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={this.handleProductSortChange}
                            ref={(r) => this.productUnitReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped"
                        />
                    </div>
                }
            </div>
        )
    }
}

DetailedSalesReportSalesSummaryTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string.isRequired,
    listData: PropTypes.array,
    locationId: PropTypes.string.isRequired,
    onDisplayMessage: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    paymentTotals: PropTypes.object,
    startDate: PropTypes.string.isRequired,
    system: PropTypes.string,
};

DetailedSalesReportSalesSummaryTable.defaultProps = {
    addField: true,
    endDate: null,
    listData: [],
    locationId: null,
    paymentTotals: {
        products: 0,
        transactions: 0,
        units: 0
    },
    startDate: null,
};

export default DetailedSalesReportSalesSummaryTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/DetailedSalesReportSalesSummaryTable.js